import { Box, Tag, Text } from '@betterment/samba-react';
import { format as formatDate, parseISO as parseDate } from 'date-fns';

import { SenderOfferFulfillment as Props } from '../data';

const tagAccentStatusDictionary: Record<Props['status'], React.ComponentProps<typeof Tag>['accent']> = {
  Active: 'teal',
  Expired: 'gold',
  Pending: 'gold',
  Upcoming: 'blue',
};

function getRewardCopy(displayReward: string, rewardType: string): string {
  switch (rewardType) {
    case 'savings_rate_boost':
      return `You've unlocked a ${displayReward} boost on your Cash Reserve`;
    case 'free_dollars_fixed':
      return `You've earned ${displayReward} managed free on your investment balance`;
    case 'free_time':
      return `You've earned ${displayReward} of your investment balance managed free`;
    default:
      throw new Error('Unknown reward type');
  }
}

function getSubheaderCopy(statusString: string, startDate: string, endDate: string): string {
  switch (statusString) {
    case 'Pending':
      return 'Your reward will be active soon';
    default:
      return `${formatDate(parseDate(startDate), 'M/d/yyyy')} - ${formatDate(parseDate(endDate), 'M/d/yyyy')}`;
  }
}

const ClaimedRewardItem: React.FC<Props> = ({ startDate, endDate, status, displayReward, rewardType }) => {
  return (
    <div>
      <Text
        as="p"
        css={{
          marginBottom: 'space.100',
        }}
      >
        {getRewardCopy(displayReward, rewardType)}
      </Text>
      <Box css={{ display: 'flex', alignItems: 'center' }}>
        <Tag accent={tagAccentStatusDictionary[status]}>{status}</Tag>
        <Text
          as="p"
          color="text.weak"
          css={{
            marginBottom: 'space.0',
            paddingLeft: 'space.100',
          }}
        >
          {getSubheaderCopy(status, startDate, endDate)}
        </Text>
      </Box>
    </div>
  );
};

export default ClaimedRewardItem;
